import React from 'react';
import PropTypes from 'prop-types';
import TextField from '@mui/material/TextField';
import ImageLogoBox from '../boxes/ImageLogoBox';

const ImageInput = ({ src, alt, IconComponent, isMobile, ...props }) => (
  <TextField
    {...props}
    InputProps={{
      ...props.InputProps,
      sx: { borderRadius: 2 },
      startAdornment: (
        <ImageLogoBox
          src={src}
          alt={alt}
          IconComponent={IconComponent}
          sx={{}}
          imgWidth={isMobile ? 48 : 60}
          imgHeight={isMobile ? 20 : 24}
        />
      ),
    }}
  />
);

ImageInput.propTypes = {
  src: PropTypes.string,
  alt: PropTypes.string,
  IconComponent: PropTypes.elementType,
  isMobile: PropTypes.bool,
  value: PropTypes.string,
  inputProps: PropTypes.shape({
    value: PropTypes.string,
  }).isRequired,
  InputProps: PropTypes.shape({
    className: PropTypes.string,
  }).isRequired,
};

ImageInput.defaultProps = {
  src: null,
  alt: '',
  IconComponent: null,
  value: null,
  isMobile: false,
};

export default ImageInput;
